import { calcEstimatedDueDate } from "./estimatedDueDate";

/**
 * Derives the estimated due date from the last menstrual period, for display on the forms.
 *
 * The format at each hop is what went wrong in KIN-2061: the input is `yyyy-MM-dd` (what
 * DatePickerField emits and what the API stores) and so is the output, because the only consumers
 * are the DatePickerField / CustomCalendar `value` prop on the Add and Edit pregnancy forms, and
 * every other caller of those passes `yyyy-MM-dd`. Returning `dd-MM-yyyy` made the calendar
 * re-parse the string with `new Date()`, which transposed day and month — and failed outright once
 * the day passed the 12th, leaving the field blank.
 *
 * It is the same function the mutations post from, rather than a second copy of the arithmetic, so
 * the date shown cannot drift from the date sent.
 */
export const calcEdd = calcEstimatedDueDate;
